import React, {useEffect} from 'react';
import {useSuspenseQuery} from "@tanstack/react-query";
import {GET_CHAMPIONS_RANK_FAILURE, GET_CHAMPIONS_RANK_SUCCESS} from "../../../store/reducer/champions";
import useGetURLTierVersion from "../useGetURLTierVersion";
import {secretApi} from "../../../api/api";
import {useDispatch} from "react-redux";

const UseChampionRank = () => {
    const {currentVersion, currentTier} = useGetURLTierVersion();
    const dispatch = useDispatch();
    const getRankData = (action) => {
        if (typeof action === 'object') {
            const url = `${process.env.REACT_APP_CACHE_API}champion/rank?platform_id=KR&tier=${encodeURIComponent(action.tier)}&game_version=${action.version}`;
            return secretApi.get(url).then((result) => result.data);
        }
    }


    const suspenseQuery = useSuspenseQuery({
        queryKey: ['championsRank', currentTier, currentVersion],
        staleTime: Infinity,
        queryFn: async () => {
            try {
                const dataObj = {
                    version: currentVersion,
                    tier: currentTier,
                }

                const getData = await getRankData(dataObj)

                return getData
            } catch (e) {
                dispatch({
                    type: GET_CHAMPIONS_RANK_FAILURE,
                    error: e,
                })
                return []
            }
        },
    })


    useEffect(() => {
        if(suspenseQuery?.data) {
            dispatch({
                type: GET_CHAMPIONS_RANK_SUCCESS,
                data: suspenseQuery.data,
            })
        }
    },[suspenseQuery.data])
    return suspenseQuery
};

export default UseChampionRank;